'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _prefixer = require('./prefixer');

var _utils = require('./utils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createRules = function createRules(name, style, parent) {
  // Extract nested rules
  var rules = createNestedRules(name, style, parent);

  if (!name) return rules;

  if (!_utils.isBrowser) style = (0, _prefixer.prefixAllFlat)(style);

  var styles = Object.keys(style).filter(function (key) {
    return (0, _utils.isArrayOrNotObject)(style[key]);
  }).map(function (key) {
    return {
      key: key,
      prop: (0, _utils.kebab)((0, _prefixer.prefixProperty)(key)),
      value: (0, _prefixer.prefixValue)(key, (0, _utils.parseValue)(key, style[key]))
    };
  }).reduce(function (a, b) {
    return (0, _utils.isArr)(b.value) ? [].concat(_toConsumableArray(a), _toConsumableArray(b.value.map(function (v) {
      return _extends({}, b, { value: (0, _prefixer.prefixValue)(b.prop, v) });
    }))) : [].concat(_toConsumableArray(a), [b]);
  }, []);

  // Add base rule
  var selector = (0, _utils.isNotSelector)(name) ? name : '.' + name;

  if ((0, _utils.isAnimation)(parent)) {
    return [{
      id: name + parent,
      order: 3,
      selector: selector,
      css: createRuleset(selector, styles)
    }];
  }

  rules.unshift({
    id: name + (parent || ''),
    order: parent ? 2 : 1,
    selector: selector,
    css: createRuleset(selector, styles, parent)
  });

  return rules;
};

var createNestedRules = function createNestedRules(name, style, parent) {
  return Object.keys(style).filter(function (key) {
    return (0, _utils.isObjectAndNotArray)(style[key]);
  }).map(function (key) {
    if ((0, _utils.isPseudoSelector)(key)) {
      return createRules(name + key, style[key], parent);
    } else if ((0, _utils.isAnimation)(key)) {
      var subrules = createRules(null, style[key], key);
      return [{
        id: key,
        order: 3,
        selector: key,
        css: key + ' { ' + subrules.map(function (r) {
          return r.css;
        }).join('') + ' }'
      }];
    } else if ((0, _utils.isMediaQuery)(key)) {
      return createRules(name, style[key], key);
    } else {
      var selector = name ? name + ' ' + key : key;
      return createRules(selector, style[key], parent);
    }
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []);
};

var createRuleset = function createRuleset(selector, styles, parent) {
  var declarations = styles.map(function (s) {
    return s.prop + ':' + s.value;
  });
  var ruleset = selector + '{' + declarations.join(';') + '}';
  return parent ? parent + ' { ' + ruleset + ' }' : ruleset;
};

exports.default = createRules;